import {
  useQueryDashboardTodo,
  useQueryDashboarStoreUpdates,
} from "api/reactQuery/queries/dashboardTodo"
import { IUserMe } from "ts/interfaces/User"
import { checkSubscription } from "utils/api"

import TableForProSchool from "./tableForProSchool"

const Table = ({ userInfo }: { userInfo: IUserMe | null }) => {
  const { data, isLoading, isError } = useQueryDashboardTodo({
    options: {
      enabled: checkSubscription(userInfo),
    },
  })

  const {
    data: dataStore,
    isLoading: isLoadingDataStore,
    isError: isErrorDataStore,
  } = useQueryDashboarStoreUpdates({
    options: {
      enabled: checkSubscription(userInfo),
    },
  })

  return (
    <TableForProSchool
      isLoading={isLoading}
      isLoadingDataStore={isLoadingDataStore}
      isError={isError}
      isErrorDataStore={isErrorDataStore}
      data={data}
      dataStore={dataStore}
    />
  )
}

export default Table
